console.log('js/listing-sidebar-button.js -> v0.1.0');
$(() => {
	const getDimensions = element => {
		const dimensions = {}

		const offset = element.offset() || null

		if (offset && offset.top) {
			dimensions.top = offset.top;
			dimensions.bottom = offset.top + element.outerHeight();
		}

		return dimensions
	}

	const markInView = (anchor, button) => {
		const offset = anchor.offset() || null

		if (offset && offset.top) {
			const anchorDimensions = getDimensions(anchor)
			const viewportTop = $(window).scrollTop();
			const windowHeight = $(window).height();
			const viewportBottom = viewportTop + windowHeight;

			const viewportIsHighEnough = anchorDimensions.bottom + button.height() > viewportTop
			const viewportIsLowEnough = anchorDimensions.top < viewportBottom - button.height();

			const anchorIsInViewport = viewportIsHighEnough && viewportIsLowEnough

			if (anchorIsInViewport) {
				button.addClass('in-view')
				button.css('left', '')
				button.css('width', '')
			} else {
				button.removeClass('in-view')

				const windowWidth = $(window).width();

				if (windowWidth > 767) {
					const box = $('.listing-query-box')
					if (box.length && box.offset() && box.offset().left) {
						button.css('left', box.offset().left);
						button.css('width', box.outerWidth());
					}
				} else {
					button.css('left', '');
					button.css('width', '');
				}

				const footer = $('.site__footer');
				const usps = $('.tripaneer-usps-footer');
				const faq = $('#faq-content');

				if (footer.length) {
					const buttonDimensions = getDimensions(button)

					const stopElement = faq.length ? faq : (usps.length ? usps : footer);
					const stopDimensions = getDimensions(stopElement)

					if (viewportBottom > stopDimensions.top) {
						button.css('bottom', viewportBottom - stopDimensions.top)
					} else {
						button.css('bottom', '')
					}
				}
			}
		}
	}

	const hasElements = (anchor, button) => anchor.length && button.length

	const mark = (anchor, button) =>
		hasElements(anchor, button) && markInView(anchor, button)

	const markSidebarButton = (anchor, button) =>
		mark($('.js-listing-sidebar-anchor-top'), $('.js-sidebar-sticky-button'))


	$(".js-sidebar-inquiry-button, .js-sidebar-reservation-button, .js-sidebar-instant-booking-button").on('click', function() {
		var bookingType = $(this).data('bookingType') 
                 || $(this).attr('data-booking-type') 
                 || 'inquiry';
  		$('#inquiry_modal').data('booking-type', bookingType);
		
		/* TODO: I'm just doing this for a fix that used to be done by sticky.js - which I removed to resolve a lot of conflicts */

		var $el = $(".js-sidebar-sticky-button");
		var $window = $(window);
		var $topAnchor = $('.js-listing-sidebar-anchor-top');

		var topWindow = $(window).scrollTop();
		var botWindow = topWindow + $(window).innerHeight();

		const offset = $topAnchor.offset()

		if (offset && offset.top) {
			var anchorTop = offset.top;

			var shouldScroll = (anchorTop <= topWindow) || (anchorTop > (botWindow - ($el.outerHeight() - ($("#listing_side_list").outerHeight()*0.80))));

			if (shouldScroll) {
				var top = 5 + anchorTop + $el.outerHeight() - $window.innerHeight();

				$('html, body').animate({ scrollTop: top }, 400);
				$(this).blur();

				return false;
			}
		}


	});

	markSidebarButton()

	var ticking = false;

	var handler = function() {
		if (!ticking) {
			window.requestAnimationFrame(function() {
				markSidebarButton()
				ticking = false;
			});
			ticking = true;
		}
	};

	$(window).on( 'resize scroll', handler );
})
